/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

/** @jsxImportSource @emotion/react */

import { FC, useContext } from 'react'

import { ExecutiveDoc, FILE_STORE_BASE } from '@builddocs/filestore-api'
import { BasketIcon } from '@builddocs/icons'
import { ViewerContext } from '@builddocs/shared/feature-pdf-viewer'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'

interface OwnProps extends ExecutiveDoc {
  handleDelete?: (id: string) => void
  isSecondary?: boolean
  isDownloadable?: boolean
}

type Props = OwnProps

export const RowPDFView: FC<Props> = (props: Props) => {
  const { title, link, isDownloadable, id, handleDelete } = props
  const viewerContext = useContext(ViewerContext)

  return (
    <Box
      alignItems="center"
      display="grid"
      gridTemplateColumns="1fr 28px"
      mb={1}
      width="100%"
    >
      <Typography
        color="primary"
        sx={{
          ' &:hover': {
            cursor: 'zoom-in',
          },
        }}
        {...(isDownloadable
          ? { href: `${FILE_STORE_BASE}${link}` }
          : {
              onClick: () =>
                viewerContext.setPDF({
                  url: `${FILE_STORE_BASE}${link}`,
                  fileName: title,
                  fileId: id,
                }),
            })}
      >
        {title}
      </Typography>
      {handleDelete && (
        <Tooltip title="Удалить">
          <IconButton onClick={() => handleDelete(id)}>
            <BasketIcon />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  )
}
